import { render, staticRenderFns } from "./ReportProjectCommentModal.vue?vue&type=template&id=55422d0f&"
import script from "./ReportProjectCommentModal.vue?vue&type=script&lang=js&"
export * from "./ReportProjectCommentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports